import { PERMISSIONS } from '@conversed/shared/src/central/constants/permissions';
import { ExperimentResultSchema } from '@conversed/shared/src/central/types/experiment-result';
import z from 'zod';
import { createRESTContract } from '../../index';

export const experimentResultContract = createRESTContract({
  getExperimentResults: {
    method: 'GET',
    path: '/experiment-result',
    permissions: [PERMISSIONS.TEST_ACCURACY.LANGSMITH],
    response: ExperimentResultSchema.array(),
  },
  deleteExperimentResult: {
    method: 'DELETE',
    path: '/experiment-result/:id',
    permissions: [PERMISSIONS.TEST_ACCURACY.LANGSMITH],
    response: z.void(),
    body: z.undefined(),
  },
  runExperiment: {
    method: 'POST',
    path: '/experiment-result/run',
    permissions: [PERMISSIONS.TEST_ACCURACY.LANGSMITH],
    body: z.object({ blockId: z.string() }),
    response: z.object({ started: z.boolean() }),
  },
  generateDatasets: {
    method: 'POST',
    path: '/experiment-result/generate-datasets',
    permissions: [PERMISSIONS.TEST_ACCURACY.LANGSMITH],
    body: z.undefined(),
    response: z.object({ created: z.number(), skipped: z.number() }),
  },
  listDatasets: {
    method: 'GET',
    path: '/experiment-result/datasets',
    permissions: [PERMISSIONS.TEST_ACCURACY.LANGSMITH],
    response: z.object({ datasets: z.array(z.string()) }),
  },
  toggleExperimentResultVisibility: {
    method: 'PATCH',
    path: '/experiment-result/:id/visibility',
    permissions: [PERMISSIONS.TEST_ACCURACY.LANGSMITH],
    body: z.object({ isVisible: z.boolean() }),
    response: z.void(),
  },
});
